import React from 'react'
import axios from 'axios';
import { useState } from 'react';
import * as XLSX from 'xlsx';

const AllApplications = ({ applications }) => {


  const [applicationStatus, setApplicationStatus] = useState();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState(""); // To track the selected filter
  const [searchQuery, setSearchQuery] = useState('');

  const [selectedApplication, setSelectedApplication] = useState(null);
  const handleOpenStatusModal = (application) => {
    console.log(application);
    setSelectedApplication(application);

    // Determine the current status based on the status array
    if (application.status[2].FinalInterview) {
      setApplicationStatus('finalinterview');
    } else if (application.status[1].Shortlisted) {
      setApplicationStatus('shortlisted');
    } else if (application.status[0].Screening) {
      setApplicationStatus('screening');
    }

    setStatusModalOpen(true);
  };

  const handleCloseStatusModal = () => {
    setApplicationStatus()
    setStatusModalOpen(false);
    setSelectedApplication();
  };
  // const [applications, setApplications] = useState([]);

  const [sortOption, setSortOption] = useState('recentlyPosted');
  const sortApplications = (applicationsToSort, option) => {
    let sortedApplications = [...applicationsToSort];

    if (option === 'recent') {
      sortedApplications.sort(
        (a, b) => new Date(b.appliedAt) - new Date(a.appliedAt)
      );
    } else if (option === 'old') {
      sortedApplications.sort(
        (a, b) => new Date(a.appliedAt) - new Date(b.appliedAt)
      );
    }

    return sortedApplications;
  };

  // const filteredApplications = sortApplications(applications, sortOption);


  // Filter applications based on status
  // const filteredByStatus = filteredApplications?.filter((application) => {
  //     if (!statusFilter) return true; // Show all if no filter is selected
  //     return application.status.some(
  //         (status) => Object.keys(status)[0] === statusFilter && status[statusFilter] === true
  //     );
  // });

  const handleDownloadCV = async (application) => {
    if (application.resumeURL) {
        window.open(application.resumeURL, '_blank');
    } else {
        console.error("Resume URL is missing.");
        alert("Resume URL is missing."); // Or handle the error in a more user-friendly way
    }
};
  const handleViewApplication = async (application) => {
    try {
      // Update the status to 'screening'
      const updatedStatus = [...application.status];
      updatedStatus[0].Screening = true; // Set screening to true
      const updatedApplication = { ...application, status: updatedStatus };

      // Update the application in your backend
      // await updateApplication(updatedApplication);

      // Then, proceed with viewing the application
      window.open(`/viewapplication/${application._id}`, '_blank'); // Use window.open for better handling of target="_blank"

    } catch (error) {
      console.error('Error updating status or viewing application:', error);
    }
  };
  const handleUpdateStatus = async (status) => {
    console.log(selectedApplication);

    setApplicationStatus(status);

    try {
      // Construct the updated status array
      const updatedStatus = selectedApplication.status.map(item => {
        const key = Object.keys(item)[0]; // Get the status key (Screening, Shortlisted, FinalInterview)
        return {
          [key]: key.toLowerCase() === status.toLowerCase(), // Set the matching status to true, others to false
          date: key.toLowerCase() === status.toLowerCase() ? new Date() : item.date //update the date if it is the correct status.
        };
      });

      // Prepare the data to send to the backend
      const updateData = {
        status: updatedStatus,
      };

      // Make the API call using axios.post (or axios.put, depending on your API)
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/jobs/updatestatus`, { // Replace with your API endpoint

        updateData,
        applicationID: selectedApplication.applicationID,
      }

      );

      // Handle the response (e.g., show a success message)
      console.log('Status updated successfully:', response.data);
      //potentially update the selected application with the new data.
      setSelectedApplication({ ...selectedApplication, status: response.data.status });

    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error('Error updating status:', error);
      if (error.response) {
        console.error('Server response:', error.response.data);
      }
    }
  };

  const downloadExcel = () => {
    const data = applications.map((application) => ({
      ApplicationID: application.applicationID,
      Email: application.email,
      AppliedAt: new Date(application.appliedAt).toLocaleString(),
      // Add other fields as needed
      ...application.answers.reduce((acc, answer) => {
        acc[answer.question] = answer.answer;
        return acc;
      }, {}),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Applications');
    XLSX.writeFile(workbook, 'applications.xlsx');
  };


  // const [, setFilteredApplications] = useState(applications);
  const [filterOption, setFilterOption] = useState('recent');


  const filteredApplications = () => {
    let sortedApplications = sortApplications(applications, sortOption);

    let statusFiltered = sortedApplications.filter((application) => {
      if (!statusFilter) return true;
      return application.status.some(
        (status) => Object.keys(status)[0] === statusFilter && status[statusFilter] === true
      );
    });

    let searchFiltered = statusFiltered.filter((application) =>
      application.applicationID.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return searchFiltered;
  };

  const finalFilteredApplications = filteredApplications();
  
  return (
    <div>
      <h2 className="text-2xl font-semibold text-[#2c2c2c] mb-6">All Applications</h2>

      <div className="flex flex-col md:flex-row gap-4 mb-6">
        {/* Search Input */}
        <div className="flex-grow">
          <input
            type="text"
            placeholder="Search by Application ID"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border p-2 rounded w-full"
          />
        </div>

        {/* Sort Select */}
        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className="border p-2 rounded md:w-48"
        >
          <option value="recent">Recent</option>
          <option value="old">Old</option>
        </select>

        {/* Download Excel Button */}
        <button className="button !rounded md:w-48" onClick={downloadExcel}>
          Download Excel
        </button>
      </div>

      {/* Status Filter Buttons */}
      <div className="flex flex-wrap gap-2 mb-4">
        <button
          className={`px-4 py-2 rounded ${statusFilter === 'Screening' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'
            }`}
          onClick={() => setStatusFilter('Screening')}
        >
          Screening
        </button>
        <button
          className={`px-4 py-2 rounded ${statusFilter === 'Shortlisted' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'
            }`}
          onClick={() => setStatusFilter('Shortlisted')}
        >
          Shortlisted
        </button>
        <button
          className={`px-4 py-2 rounded ${statusFilter === 'FinalInterview' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'
            }`}
          onClick={() => setStatusFilter('FinalInterview')}
        >
          Final Interview
        </button>
        <button
          className={`px-4 py-2 rounded ${statusFilter === '' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'
            }`}
          onClick={() => setStatusFilter('')}
        >
          All Applications
        </button>
      </div>

      {/* Application List */}
      <div className="grid grid-cols-1 gap-4">
        {finalFilteredApplications.map((application) => (
          <div
            key={application.applicationID}
            className="bg-[#fff] text-black p-4 rounded shadow flex justify-between items-center"
          >
            <div>
              <h3 className="text-lg font-bold">{application.applicationID}</h3>
              <p>{application.email}</p>
            </div>

            <div className="flex gap-2">
              <button
                className="bg-blue-500 text-white px-3 py-1 rounded text-sm"
                onClick={() => handleViewApplication(application)}
              >
                View
              </button>
              <button
                className="bg-green-500 text-white px-3 py-1 rounded text-sm"
                onClick={() => handleDownloadCV(application)}
              >
                CV
              </button>
              <button
                className="bg-yellow-500 text-white px-3 py-1 rounded text-sm"
                onClick={() => handleOpenStatusModal(application)}
              >
                Status
              </button>
              <button
                className="bg-yellow-500 text-white px-3 py-1 rounded text-sm"
                onClick={() => handleOpenStatusModal(application)}
              >
                Download to Excel
              </button>
            </div>
          </div>
        ))}

        {/* Status Modal */}
        {statusModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-8 rounded-md min-w-96">
              <h2 className="text-lg font-semibold mb-6">Edit Status</h2>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Status:
                </label>
                <div className="mt-4">
                  <div className="flex items-center justify-between relative">
                    {/* Status Modal Content - Same as before */}
                    <div className="relative z-10 mr-4">
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus === 'screening' ||
                            applicationStatus === 'shortlisted' ||
                            applicationStatus === 'finalinterview'
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-300 text-gray-600'
                          }`}
                      >
                        1
                      </div>
                      <span className="absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                        Screening
                      </span>
                    </div>

                    <div
                      className={`h-1 bg-gray-300 absolute top-5 left-6 w-[calc(50%-40px)] ${applicationStatus === 'shortlisted' ||
                          applicationStatus === 'finalinterview'
                          ? '!bg-blue-500'
                          : ''
                        }`}
                    />

                    <div className="relative z-10 mx-4">
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus === 'shortlisted' ||
                            applicationStatus === 'finalinterview'
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-300 text-gray-600'
                          }`}
                      >
                        2
                      </div>
                      <span className="absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                        Shortlisted
                      </span>
                    </div>

                    <div
                      className={`h-1 bg-gray-300 absolute top-5 right-6 w-[calc(50%-40px)] ${applicationStatus === 'finalinterview' ? '!bg-blue-500' : ''
                        }`}
                    />

                    <div className="relative z-10 ml-4">
                      <div
                        className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus === 'finalinterview'
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-300 text-gray-600'
                          }`}
                      >
                        3
                      </div>
                      <span className="w-full absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                        Final-Interview
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-center gap-4 mt-14">
                    {/* Status Update Buttons */}
                    <button
                      className={`px-4 py-2 rounded text-sm ${applicationStatus === 'screening'
                          ? 'bg-blue-500 text-white'
                          : 'bg-gray-200'
                        }`}
                      onClick={() => handleUpdateStatus('screening')}
                    >
                      Set to Screening
                    </button>
                    <button
                      className={`px-4 py-2 rounded text-sm ${applicationStatus === 'shortlisted'
                          ? 'bg-blue-500 text-white'
                          : 'bg-gray-200'
                        }`}
                      onClick={() => handleUpdateStatus('shortlisted')}
                    >
                      Set to Shortlisted
                    </button>
                    <button
                      className={`px-4 py-2 rounded text-sm ${applicationStatus === 'finalinterview'
                          ? 'bg-blue-500 text-white'
                          : 'bg-gray-200'
                        }`}
                      onClick={() => handleUpdateStatus('finalinterview')}
                    >
                      Set to Final Interview
                    </button>
                  </div>
                </div>
              </div>

              <button className="bg-red-300 px-5 py-2 rounded text-sm" onClick={handleCloseStatusModal}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default AllApplications;
